// Reads are audited server-side and strict mode loads twice, so concurrent callers share one request.
export const shareInFlight = <T>(
  start: () => Promise<T>
): (() => Promise<T>) => {
  let pending: Promise<T> | null = null
  return () => {
    pending ??= start().finally(() => {
      pending = null
    })
    return pending
  }
}
